<div class="response-project-view">
  @if (isNewProjectRoute && !project()) {
    <div class="response-project-view-card">
      <div class="response-project-view-header">
        <ng-container *ngIf="isEditingTitle; else newTitleDisplay">
          <div class="response-project-view-header-edit">
            <input
              type="text"
              class="response-project-view-header-input"
              [(ngModel)]="editedTitle"
              (keydown)="onNewTitleKeyDown($event)"
              (blur)="onNewTitleBlur()"
              placeholder="Nommez ce projet..."
              autofocus
            />
          </div>
        </ng-container>
        <ng-template #newTitleDisplay>
          <div class="response-project-view-header-container">
            <p class="response-project-view-header-title">{{ editedTitle }}</p>
            <button
              type="button"
              class="response-project-view-header-edit-btn"
              (click)="startEditNewTitle()"
              [attr.aria-label]="'tenders.responses.rename.edit' | translate"
            >
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </button>
          </div>
        </ng-template>
      </div>
      <div class="response-project-view-content">
        <div class="response-project-view-content-inner">
          <div class="response-project-documents">
            <app-response-project-document-uploader
              [title]="'tenders.responses.documents.section-dce' | translate"
              [mainTitle]="'tenders.responses.documents.empty-main-title-dce' | translate"
              scope="dce"
              [emptyStateSubhint]="'tenders.responses.documents.auto-categorize-hint' | translate"
              [projectId]="null"
              [defaultDocumentSubtypeId]="defaultDceSubtypeId"
              [subtypeOptions]="dceSubtypeOptions"
              [configMode]="true"
              (continueClicked)="onNewProjectContinueClicked()"
            ></app-response-project-document-uploader>
          </div>
        </div>
      </div>
    </div>
  }
  @if (project(); as project) {
    <div class="response-project-view-card">
      <div class="response-project-view-header">
        <ng-container *ngIf="isEditingTitle && !isExpired && !isClosed; else titleDisplay">
          <div class="response-project-view-header-edit">
            <input
              type="text"
              class="response-project-view-header-input"
              [(ngModel)]="editedTitle"
              (keydown)="onTitleKeyDown($event, project.id, project.name)"
              (blur)="saveTitle(project.id, project.name)"
              placeholder="Nommez ce projet..."
              autofocus
            />
          </div>
        </ng-container>
        <ng-template #titleDisplay>
          <div class="response-project-view-header-container">
            <p
              class="response-project-view-header-title"
              [class.response-project-view-header-title--frozen]="isExpired"
              [ngbTooltip]="project.name"
              placement="bottom"
              tooltipClass="response-project-view-title-tooltip"
              overflowTooltip
            >
              {{ project.name }}
            </p>
            @if (!isExpired) {
              <button
                type="button"
                class="response-project-view-header-edit-btn"
                (click)="startEditTitle(project.name)"
                [attr.aria-label]="'tenders.responses.rename.edit' | translate"
              >
                <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
              <div class="response-project-view-header-spacer"></div>
              <app-response-status-badge
                [closed]="isClosed"
                (openOrCloseProject)="openOrCloseProject(project.id, $event)"
              ></app-response-status-badge>
            }
          </div>
        </ng-template>
      </div>
      @if (!addinInstalled()) {
        <div class="addin-banner">
          <div class="addin-banner__header">
            <div class="addin-banner__word-icon" aria-hidden="true">W</div>
            <div class="addin-banner__text">
              <p class="addin-banner__label">{{ 'tenders.responses.addin-banner.step-label' | translate }}</p>
              <p class="addin-banner__title">{{ 'tenders.responses.addin-banner.title' | translate }}</p>
            </div>
            <button type="button" class="addin-banner__cta" (click)="addinBannerExpanded = !addinBannerExpanded">
              {{ 'tenders.responses.addin-banner.cta' | translate }}
              <i
                class="ph ph-caret-down addin-banner__cta-caret"
                [class.addin-banner__cta-caret--open]="addinBannerExpanded"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          @if (addinBannerExpanded) {
            <div class="addin-banner__content">
              <app-response-project-wizard-word-card [showHeader]="false"></app-response-project-wizard-word-card>
            </div>
          }
        </div>
      }

      <div class="response-project-view-content" cdkScrollable>
        <div class="response-project-view-content-inner">
          @if (isExpired) {
            <div class="expired-notice">
              <div class="expired-notice__icon">👋</div>
              <div class="expired-notice__text">
                <p class="expired-notice__label">
                  @if (isTrial) {
                    {{ 'tenders.responses.expired-notice.label-trial' | translate: { plan: expiredPlanLabel } }}
                  } @else {
                    {{ 'tenders.responses.expired-notice.label-paid' | translate }}
                  }
                </p>
                <p class="expired-notice__body">
                  @if (isTrial) {
                    {{ 'tenders.responses.expired-notice.body-trial' | translate }}
                  } @else {
                    {{ 'tenders.responses.expired-notice.body-paid' | translate }}
                  }
                </p>
              </div>
              <a class="expired-notice__cta" [href]="mailtoHref" target="_blank">
                <i class="ph ph-envelope"></i>
                {{ 'tenders.responses.expired-notice.cta' | translate }}
              </a>
            </div>
          }
          <div class="response-project-documents">
            @for (id of [project.id]; track id) {
              <app-response-project-document-uploader
                [title]="'tenders.responses.documents.section-dce' | translate"
                [mainTitle]="'tenders.responses.documents.empty-main-title-dce' | translate"
                scope="dce"
                [emptyStateSubhint]="'tenders.responses.documents.auto-categorize-hint' | translate"
                [projectId]="project.id"
                [defaultDocumentSubtypeId]="defaultDceSubtypeId"
                [subtypeOptions]="dceSubtypeOptions"
                [configMode]="true"
                [contentDisabled]="isExpired"
                [collapsed]="isExpired || isClosed"
                (continueClicked)="onDceContinueClicked()"
                (projectNotFound)="onProjectNotFound(project.id)"
                (documentNotFound)="onDocumentNotFound()"
                (uploadStateChange)="onUploadStateChange()"
              ></app-response-project-document-uploader>
              @if (blocksRevealed) {
                <div class="response-project-view-reveal response-project-view-reveal--1">
                  <app-reference-documents-section
                    [title]="'tenders.responses.documents.section-internal' | translate"
                    [projectId]="project.id"
                    [defaultDocumentSubtypeId]="defaultInternalSubtypeId"
                    [subtypeOptions]="internalSubtypeOptions"
                    [configMode]="true"
                    (projectNotFound)="onProjectNotFound(project.id)"
                    (documentNotFound)="onDocumentNotFound()"
                    [contentDisabled]="isExpired"
                    [collapsed]="isExpired || isClosed"
                    (uploadStateChange)="onUploadStateChange()"
                  ></app-reference-documents-section>
                </div>
              }
            }
          </div>

          @if (blocksRevealed) {
            <div class="response-project-view-reveal response-project-view-reveal--2">
              <app-response-project-instructions
                [projectId]="project.id"
                [instructions]="project.user_instructions ?? ''"
                [disabled]="isExpired"
                [collapsed]="isClosed"
                (projectNotFound)="onProjectNotFound(project.id)"
              ></app-response-project-instructions>
            </div>

            <div class="response-project-view-reveal response-project-view-reveal--3">
              <div class="response-project-view-section-label">
                {{ 'tenders.responses.remove-project.section-label' | translate }}
                <span class="response-project-view-section-label-line"></span>
              </div>
              <div class="response-project-view-remove-project">
                <div>
                  <h4 class="response-project-view-remove-project-title">
                    {{ 'tenders.responses.remove-project.title' | translate }}
                  </h4>
                  <p class="response-project-view-remove-project-text">
                    {{ 'tenders.responses.remove-project.text' | translate: { name: project.name } }}
                  </p>
                </div>
                <button type="button" class="response-project-view-delete-btn" (click)="openDeleteProjectModal(project.id, project.name)">
                  <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                  {{ 'tenders.responses.remove-project.delete' | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
<app-response-toast></app-response-toast>
